

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Query } from '@/database';

@Component
export default class Table extends Vue {
    @Prop() private query!: Query;
    @Prop() private title!: string;
    @Prop() private complete?: boolean;
    @Prop() private wide?: boolean;
    @Prop() private left?: boolean;
    @Prop() private scroll?: boolean;
}
